import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const guideSchema = z.object({
  email: z.string().trim().email().max(255),
});

export const requestInterviewGuide = createServerFn({ method: "POST" })
  .validator((input) => guideSchema.parse(input))
  .handler(async ({ data }) => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");

    const { data: inserted, error } = await supabaseAdmin
      .from("guide_signups")
      .insert({ email: data.email })
      .select("id")
      .single();

    if (error) {
      console.error("Failed to save guide signup:", error);
      throw new Error("Failed to save your email. Please try again.");
    }

    const { sendTemplateEmail } = await import("@/lib/email-templates/send-email");
    await sendTemplateEmail("interview-guide", data.email, {
      idempotencyKey: `interview-guide-${inserted?.id ?? data.email}`,
    });

    return { success: true };
  });
